import styles from "./styles.module.css";

export function ComponentSpacing() {
  return <div className={styles.space}></div>;
}

export function ComponentHalfSpacing() {
  return <div className={styles["half-space"]}></div>;
}
